import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import AnimateHeight from 'react-animate-height'
import { useSelector } from 'react-redux'

import { ReactComponent as ArrowIcon } from '../../assets/icons/chevron-arrow-down.svg'

import { isNewStylesThemeEnabledSelector } from '../../modules/selectors/app'

import useStyles from './style'
import * as classes from './styles.css'

function Spoiler({
  title,
  initialOpen,
  className,
  children,
  triggerOpen,
  spoilerTitleClassName,
  arrowIconClassName,
  isSmall = false,
  hasMarginLeft = true,
  titleColor
}) {
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)

  const [height, setHeight] = useState(initialOpen ? 'auto' : 0)
  const legacyClasses = useStyles({
    opened: !!height,
    isSmall,
    hasMarginLeft,
    titleColor
  })

  const vanillaClasses = {
    spoiler: classes.spoiler,
    arrowIcon: classes.arrowIcon({
      opened: !!height,
      isSmall
    }),
    spoilerTitle: classes.spoilerTitle({
      isSmall,
      hasMarginLeft
    }),
    spoilerBody: classes.spoilerBody
  }
  const activeClasses = isNewStylesThemeEnabled ? vanillaClasses : legacyClasses

  const onToggleSpoiler = () => {
    setHeight(height === 0 ? 'auto' : 0)
  }

  useEffect(() => {
    if (triggerOpen) {
      setHeight('auto')
    }
  }, [triggerOpen])

  return (
    <div className={classnames(activeClasses.spoiler, 'spoiler', className)}>
      <div
        className={classnames('spoilerTitle', activeClasses.spoilerTitle, spoilerTitleClassName)}
        onClick={onToggleSpoiler}
      >
        <ArrowIcon className={classnames(activeClasses.arrowIcon, arrowIconClassName)} />
        {title}
      </div>
      <AnimateHeight duration={300} height={height}>
        <div className={activeClasses.spoilerBody}>{children}</div>
      </AnimateHeight>
    </div>
  )
}

Spoiler.propTypes = {
  title: PropTypes.string,
  initialOpen: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  triggerOpen: PropTypes.bool,
  spoilerTitleClassName: PropTypes.string,
  arrowIconClassName: PropTypes.string,
  isSmall: PropTypes.bool,
  hasMarginLeft: PropTypes.bool,
  titleColor: PropTypes.string
}

export default Spoiler
